import { FunctionComponent } from "react";

type TeamCardType = {
  userDescription1?: string;
  userImageUrl?: string;
  userRole?: string;
  jobTitle?: string;
};

const TeamCard: FunctionComponent<TeamCardType> = ({
  userDescription1,
  userImageUrl,
  userRole,
  jobTitle,
}) => {
  return (
    <div className="w-[15.88rem] rounded-3xl bg-blueviolet overflow-hidden shrink-0 flex flex-col items-start justify-start text-left text-[1.56rem]  font-anek-devanagari">
      <img
        className="w-[15.88rem] relative h-[12.75rem] object-cover"
        alt=""
        src={userDescription1}
      />
      <div className="w-[15.88rem] nb rounded-t-none rounded-b-[27.55px] [background:linear-gradient(rgba(29,_29,_29,_0.4),_rgba(29,_29,_29,_0.4)),_#0d0d0d] shadow-[3px_4px_4px_rgba(0,_0,_0,_0.25)] box-border h-[15.25rem] flex flex-col items-center justify-center py-[0rem] px-[0.88rem] border-[2px] border-solid border-mistyrose">
        <div className="self-stretch h-[12.19rem] flex flex-col items-center justify-between">
          <div className="self-stretch flex flex-row items-center justify-start gap-[1.19rem] font-anek-devanagari">
            <div className="relative leading-[1.5rem]  text-transparent !bg-clip-text [background:linear-gradient(rgba(153,_69,_255,_0.04),_rgba(153,_69,_255,_0.04)),_#fff] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] inline-block h-[1.19rem] shrink-0">
              {userImageUrl}
            </div>
            <img
              className="w-[2.13rem] relative h-[2.13rem] object-cover mix-blend-color-dodge"
              alt=""
              src="/twitterxlogo42561-1@2x.png"
            />
          </div>
          <div className="self-stretch relative text-[0.94rem] leading-[1.38rem] text-transparent !bg-clip-text [background:linear-gradient(rgba(153,_69,_255,_0.04),_rgba(153,_69,_255,_0.04)),_#b8b8b8] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">
            {userRole}
          </div>
            <div className="self-stretch custom rounded-21xl overflow-hidden flex flex-row items-center justify-center py-[0.56rem] pt-[0.85rem] px-[0rem] text-[1.13rem] border-[2px] border-solid border-neutral-09">
            <div className="relative leading-[1.13rem] text-transparent !bg-clip-text [background:linear-gradient(rgba(153,_69,_255,_0.04),_rgba(153,_69,_255,_0.04)),_#fff] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]">
              {jobTitle}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
